import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { StylesProvider } from '@material-ui/styles';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

ReactDOM.render(
  <HelmetProvider>
    <StylesProvider injectFirst>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </StylesProvider>
  </HelmetProvider>,
  document.getElementById('root')
);
